<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div :class="cn('relative flex grow flex-col gap-5 max-w-full overflow-x-hidden px-5 py-4', props.class)">
    <slot />
  </div>
</template>
